import classNames from "classnames";
import React from "react";
import { Transition } from "react-transition-group";

import { Icon } from "../../atoms/icon";
import { Button } from "../../../components/atoms/button";
import styles from "./index.module.scss";

interface OwnProps {
  openMode: "always" | "closed" | "opened";
  onToggleRequest?: () => void;
}

class MobileFiltersPanel extends React.PureComponent<OwnProps> {
  public render() {
    const { children, openMode, onToggleRequest } = this.props;

    return (
      <div className={styles.mobileFilters}>
        <Transition
          in={openMode === "always" || openMode === "opened"}
          timeout={{ enter: 0, exit: 0 }}
          mountOnEnter
          unmountOnExit
        >
          {(status: unknown) => (
            <div
              className={classNames(styles.filters, {
                [styles.visible]: status === "entered",
                [styles.hidden]: status !== "entered",
              })}
            >
              <div className={styles.items}>{children}</div>
            </div>
          )}
        </Transition>
        {openMode === "always" ? null : openMode === "opened" ? (
          <Button
            size="midSmall"
            color="subdued"
            onClick={() => onToggleRequest && onToggleRequest()}
          >
            <Icon
              className={classNames(styles.icon, styles.clickable)}
              name="chevron_up"
              color="black55"
            />
            閉じる
          </Button>
        ) : (
          <Button
            size="midSmall"
            color="secondary"
            onClick={() => onToggleRequest && onToggleRequest()}
          >
            <Icon
              className={classNames(styles.icon, styles.clickable)}
              name="chevron_down"
            />
            絞り込み条件を見る
          </Button>
        )}
      </div>
    );
  }
}

export { MobileFiltersPanel };
export { default as MobileFilterItem } from "./MobileFilterItem";
